var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountWorks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 18.563 45 17.438C45 16.8167 44.4963 16.313 43.875 16.313L24.188 16.313 24.188 13.5 29.25 13.5C30.4926 13.5 31.5 12.4926 31.5 11.25L31.5 2.25C31.5 1.00736 30.4926 -4.44089e-16 29.25 -4.44089e-16L15.75 0C14.5074 4.44089e-16 13.5 1.00736 13.5 2.25L13.5 11.25C13.5 12.4926 14.5074 13.5 15.75 13.5L20.813 13.5 20.813 16.313 1.125 16.313C0.50368 16.313 -2.22045e-16 16.8167 0 17.438L0 18.563C0 19.1843 0.50368 19.688 1.125 19.688L8.438 19.688 8.438 22.5 4.5 22.5C3.25736 22.5 2.25 23.5074 2.25 24.75L2.25 33.75C2.25 34.9926 3.25736 36 4.5 36L15.75 36C16.9926 36 18 34.9926 18 33.75L18 24.75C18 23.5074 16.9926 22.5 15.75 22.5L11.813 22.5 11.813 19.688 33.188 19.688 33.188 22.5 29.25 22.5C28.0074 22.5 27 23.5074 27 24.75L27 33.75C27 34.9926 28.0074 36 29.25 36L40.5 36C41.7426 36 42.75 34.9926 42.75 33.75L42.75 24.75C42.75 23.5074 41.7426 22.5 40.5 22.5L36.563 22.5 36.563 19.688 43.876 19.688C44.4969 19.6874 45 19.1839 45 18.563ZM18 9 18 4.5 27 4.5 27 9ZM13.5 31.5 6.75 31.5 6.75 27 13.5 27ZM38.25 31.5 31.5 31.5 31.5 27 38.25 27Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountWorks);
export default __webpack_public_path__ + "static/media/account_works.7bfcc3d082217be991ea880b47e1dc87.svg";
export { ForwardRef as ReactComponent };